<div *ngIf="loading" class="loading">
  <div class="sk-line w60"></div>
  <div class="sk-line w80"></div>
  <div class="sk-line w40"></div>
</div>

<div *ngIf="!loading">
  <div *ngIf="error" class="alert alert-error">{{ error }}</div>

  <!-- Summary -->
  <section class="card summary">
    <div class="row">
      <div class="left">
        <div class="title">Order #{{ publicOrderCode }}</div>
        <div class="meta">
          <span class="chip">
            {{ details?.orderStatus || details?.status || "" | titlecase }}
          </span>
          <span class="dot">•</span>
          <span class="chip alt">
            {{ details?.orderType || "" | titlecase }}
          </span>
        </div>
      </div>
      <div class="right">
        <div class="total">
          {{
            details?.totalOrderModifiedPrice ?? details?.total ?? 0
              | currency: "GBP" : "symbol" : "1.2-2"
          }}
        </div>
        <div class="refundable">
          Refundable up to:
          <strong>{{
            refundableTotal | currency: "GBP" : "symbol" : "1.2-2"
          }}</strong>
        </div>
      </div>
    </div>
  </section>

  <!-- Form -->
  <form [formGroup]="form" (ngSubmit)="submit()" class="form-grid">
    <div class="field">
      <label class="label">Refund type</label>
      <div class="radio-row">
        <label
          ><input type="radio" formControlName="mode" value="full" /> Full
          refund</label
        >
        <label
          ><input type="radio" formControlName="mode" value="items" /> Item
          refund</label
        >
        <label
          ><input type="radio" formControlName="mode" value="partial" /> Partial
          refund</label
        >
      </div>
    </div>

    <!-- Amount -->
    <div class="field amount">
      <label class="label">Amount</label>
      <input
        type="number"
        step="0.01"
        min="0.01"
        formControlName="amount"
        [disabled]="form.get('mode')!.value !== 'partial'"
      />
      <div class="hint">Max {{ refundableTotal | currency: "GBP" }}</div>
    </div>

    <!-- Item Refund mode -->
    <div class="field" *ngIf="form.get('mode')!.value === 'items'">
      <label class="label">Select items and quantities to refund</label>

      <div formArrayName="items" class="items">
        <div
          class="item"
          *ngFor="let _ of items.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="item-row">
            <div class="name">{{ items.at(i).get("name")!.value }}</div>

            <div class="qty-block">
              <span class="x">Qty:</span>
              <select class="qty" formControlName="refundQty">
                <option
                  *ngFor="let n of range(items.at(i).get('purchQty')!.value)"
                  [value]="n"
                >
                  {{ n }}
                </option>
              </select>
              <span class="cap"
                >/ {{ items.at(i).get("purchQty")!.value }}</span
              >
            </div>

            <div class="unit">
              ×
              {{
                items.at(i).get("unitPrice")!.value | currency: "GBP" : "symbol"
              }}
            </div>

            <div class="price">
              {{
                items.at(i).get("refundQty")!.value *
                  items.at(i).get("unitPrice")!.value
                  | currency: "GBP" : "symbol"
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="hint">The total amount will be calculated automatically.</div>
    </div>

    <div class="field">
      <label class="label">Reason (optional)</label>
      <input
        type="text"
        formControlName="reason"
        placeholder="E.g. Missing item, wrong order…"
      />
    </div>

    <div class="actions">
      <button
        type="button"
        class="btn"
        (click)="cancelled.emit()"
        [disabled]="submitting"
      >
        Cancel
      </button>
      <button type="submit" class="btn danger" [disabled]="submitting">
        {{ submitting ? "Submitting…" : "Confirm refund" }}
      </button>
    </div>
  </form>
</div>
